import React, { useState } from 'react'
import "../../Assets/Css/Designation.scss"
import { Link, useLocation } from 'react-router-dom'

const ViewDesignation = () => {
     const [isOpen, setIsOpen] = useState(false);
     const location = useLocation();
     const data = location?.state?.data?.allData;
     const toggleDropdown = () => {
          setIsOpen(!isOpen);
     };
     return (
          <>
               {/* <div className='designation-view-container'>
                    <div className='designation-view-header'>
                         <p className='title-part'>Designation Details</p>
                    </div>

                    <div className='designation-common-card'>
                         <div className='card-row'>
                              <p className='card-row-title'>Name</p>
                              <p className='card-row-title'>Director</p>
                         </div>

                         <div className='card-row'>
                              <p className='card-row-value'>{data?.name}</p>
                              <p className='card-row-value'>{data?.parent_designation}</p>
                         </div>

                         <div className="menu-button">
                              <img
                                   src={actionbutton}
                                   alt="Menu"
                                   onClick={toggleDropdown}
                                   aria-expanded={isOpen}
                                   style={{ cursor: 'pointer' }}
                              />

                              {isOpen && (
                                   <div className="dropdown-menu show">
                                        <div className="d-grid">
                                             <Link
                                                  className="dropdown-item"
                                                  to="/designation/edit"
                                             >
                                                  Edit
                                             </Link>

                                             <Link
                                                  className="dropdown-item"
                                                  onClick={() => {
                                                       setIsOpen(false);
                                                  }}
                                                  to=""
                                             >
                                                  Delete
                                             </Link>
                                        </div>
                                   </div>
                              )}
                         </div>
                    </div>

               </div> */}
               <div className="viewDepartment-main">
                    <div className="page-title">
                         <div className="d-flex justify-content-between align-items-center">
                              <h4>Designation</h4>
                         </div>
                    </div>
                    <div className="content-part">
                         <div className="row">
                              <div className="col-lg-12">
                                   <div className="left-part">
                                        <div className="custom-row">
                                             <div className="department-detail">
                                                  <div className="d-flex justify-content-between align-items-center">
                                                       <h5 className='department-detail-divider'>Designation Details</h5>
                                                  </div>
                                                  <div className="row">
                                                       <div className="input-groups">
                                                            <div className="col-3">
                                                                 <h6 className='labels'>Designation Name</h6>
                                                            </div>
                                                            <div className="col-9">
                                                                 <h6 className='labels'>{data?.name}</h6>
                                                            </div>
                                                       </div>

                                                       <div className="input-groups">
                                                            <div className="col-3">
                                                                 <h6 className='labels'>Parent Designation</h6>
                                                            </div>
                                                            <div className="col-9">
                                                                 <h6 className='labels'>{data?.parent_designation}</h6>
                                                            </div>
                                                       </div>

                                                  </div>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
          </>
     )
}

export default ViewDesignation
